module.exports = __webpack_public_path__ + "../resources/img/bg_pv1_02.d1fccef2.png";